/**
 * Created by piotr.pozniak@thebeaverhead.com on 22/12/2021.
 */

const CalendarsMiddleware = (storeAPI) => (next) => (action) => {
  switch (action.type) {
    case "CALENDARS_FETCH_FULFILLED":
      action.payload = action.payload.map((i) => {
        if (i.integration && !Number.parseInt(i.integration.available)) {
          i.integration = null;
        }
        return i;
      });

      break;

    case "CALENDAR_FETCH_FULFILLED":
    case "CALENDAR_UPDATE_FULFILLED":
      if (
        action.payload.integration &&
        !Number.parseInt(action.payload.integration.available)
      ) {
        action.payload.integration = null;
      }

      let model = storeAPI.getState().calendar.model;
      if (!model) {
        model = storeAPI
          .getState()
          .calendars.collection.find((i) => i.uuid === action.payload.uuid);
      }

      break;
  }

  next(action);
};

export default CalendarsMiddleware;
